@if (cropperSettings) {
  @if (!previewUrl) {
    <app-crop-upload
      class="bo-non-field-errors"
      [title]="title"
      [text]="text"
      [settings]="cropperSettings"
      [fieldId]="fieldId"
      (uploadSuccess)="pictureUploaded($event)">
    </app-crop-upload>
  } @else {
    <div class="text-center">
      <div class="preview-container">
        @if (previewUrl) {
          <img
            [src]="previewUrl"
            alt="Preview image"
            class="img-fluid d-block"
            [ngStyle]="{
              'max-height': '400px',
              'border-radius': '1rem',
            }" />
        }
      </div>
      <br />
      <button
        class="btn btn-sm btn-light-on-white"
        (click)="onChange()"
        id="upload_change_button">
        Re-upload image
      </button>
    </div>
  }
  <!-- Barcode Validator Component (triggers after upload) -->
  @if (enableBarcodeValidation && uploadedImageUrl) {
    <app-barcode-validator
      [imageDataUrl]="uploadedImageUrl"
      [autoValidate]="false"
      [documentType]="documentType"
      (validationResult)="onBarcodeValidationResult($event)"
      (validationStatusChange)="onBarcodeValidationStatusChange($event)">
    </app-barcode-validator>
  }
} @else {
  <div class="loader-wrapper">
    <div class="loader"></div>
  </div>
}
